import React from 'react'
import { useTopCpuQueries } from '../../Hooks/Features/Inspectra/useTopCpuQueries'
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid'

const TopCpuQueries = ({projectChanged}) => {
    const { sessionCols, rowData, loader } = useTopCpuQueries({projectChanged})

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Top CPU Queries</div>
            </div>
            <div className="mt-2 w100" style={{ height: "400px", overflow: "auto" }}>
                <CommonGrid columns={sessionCols} data={[{ title: "", id: "all", children: rowData }]} loader={loader} headerHeight={50} />
            </div>
        </div>
    )
}

export default TopCpuQueries
